import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    api_url: 'https://iranrepaircenter.ir/panel/api/',
    loginmodal :false,
    reset_password : false,
    ratings : false,
    financial : false,
    rules : false,
    scores : false,
    help : false,
    is_login:false,
    cities : [],
    cats : [],
    brands : [],
    massages : [],
    brands_changes : [],
    brands_category : [],
    agent_brands : [],
    agent_brands_changes : [],
user : [],
user_changes : [],
user_branding : [],
user_branding_changes : [],
  },
  mutations: {
    increment () {
      Cookies.set('foo', 'bar')
    }
  },
  actions: {
  },
  modules: {
  }
})
